
export const MetaData = {
    meta_description:"ABS Industrial Products | We Bring You Quality Industrial Tools",
    meta_keywords:"tools, metalworking tools, machine tool accessories, cutting tools, solid carbide, indexable, high speed steel, measuring, inspection tools, Metal Working, inspection, Accessories, die supplies, abrasives, end mills, drills, work holding",
    meta_title:"ABS Industrial Products | We Bring You Quality Industrial Tools",
    title:"ABS Industrial Products | We Bring You Quality Industrial Tools",
    __typename:"CmsPage"
}